import { render, staticRenderFns } from "./tariffs-table.vue?vue&type=template&id=24cd0dab"
import script from "./tariffs-table.vue?vue&type=script&lang=js"
export * from "./tariffs-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports